import { optimisationReviewId as optimisationReviewIdCodec, voiceAgentId as voiceAgentIdCodec, } from "../../id/codec.js";
/** The outbox topic the factory's dedicated loop claims (DD32-7). */
export const OPTIMISATION_REVIEW_RUN_TOPIC = "optimisation_review.run";
export const OPTIMISATION_REVIEW_DEPTH = Object.freeze(["standard", "ultra"]);
export const OPTIMISATION_REVIEW_SCOPE = Object.freeze([
    "last_24h",
    "last_7d",
    "since_last_version",
]);
/** An ISO-8601 instant with an explicit offset, as `Date.prototype.toISOString` writes it. */
const INSTANT = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{1,9})?(?:Z|[+-]\d{2}:\d{2})$/u;
function isOneOf(set, value) {
    return typeof value === "string" && set.includes(value);
}
/** Parses the stored payload, naming the first field that is missing or malformed. */
export function optimisationReviewRunPayloadOf(payload) {
    if (typeof payload !== "object" || payload === null || Array.isArray(payload)) {
        return { ok: false, problem: "payload" };
    }
    const raw = payload;
    const optimisationReviewId = raw["optimisation_review_id"];
    if (typeof optimisationReviewId !== "string" || !optimisationReviewIdCodec.is(optimisationReviewId)) {
        return { ok: false, problem: "optimisation_review_id" };
    }
    const voiceAgentId = raw["voice_agent_id"];
    if (typeof voiceAgentId !== "string" || !voiceAgentIdCodec.is(voiceAgentId)) {
        return { ok: false, problem: "voice_agent_id" };
    }
    const depth = raw["depth"];
    if (!isOneOf(OPTIMISATION_REVIEW_DEPTH, depth))
        return { ok: false, problem: "depth" };
    const scope = raw["scope"];
    if (!isOneOf(OPTIMISATION_REVIEW_SCOPE, scope))
        return { ok: false, problem: "scope" };
    const requestedAt = raw["requested_at"];
    if (typeof requestedAt !== "string" || !INSTANT.test(requestedAt))
        return { ok: false, problem: "requested_at" };
    const instant = new Date(requestedAt);
    if (Number.isNaN(instant.getTime()))
        return { ok: false, problem: "requested_at" };
    return {
        ok: true,
        payload: { optimisationReviewId, voiceAgentId, depth, scope, requestedAt: instant },
    };
}
// ── optimisation_review.finished (ADDED 2026-10-28, plan-032 DB-OR, design §43.7, §43.12) ───────────────────────────
/** The worker topic the finish and the failure enqueue, in their own db_transaction (WRK-OR answers it). */
export const OPTIMISATION_REVIEW_FINISHED_TOPIC = "optimisation_review.finished";
export const OPTIMISATION_REVIEW_FINISHED_OUTCOME = ["done", "failed"];
/** The JSON written to `outbox_message.payload`: an id and a code, never a finding text (design §43.12). */
export function optimisationReviewFinishedWireOf(payload) {
    return { optimisation_review_id: payload.optimisationReviewId, outcome: payload.outcome };
}
/** Reads the payload back; `null` when it is not exactly the id and a known outcome (a producer defect). */
export function optimisationReviewFinishedPayloadOf(payload) {
    if (typeof payload !== "object" || payload === null || Array.isArray(payload))
        return null;
    const raw = payload;
    const optimisationReviewId = raw["optimisation_review_id"];
    const outcome = raw["outcome"];
    if (typeof optimisationReviewId !== "string" || !optimisationReviewIdCodec.is(optimisationReviewId))
        return null;
    if (!isOneOf(OPTIMISATION_REVIEW_FINISHED_OUTCOME, outcome))
        return null;
    return { optimisationReviewId, outcome };
}
//# sourceMappingURL=run-payload.js.map